import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FaPaperPlane } from "react-icons/fa";
import { getMessages } from "../functions/firebaseFunctions";
import { dateTime } from '../functions/functions';
import MessageItem from './MessageItem'; 

import { db, auth } from '../functions/firebaseFunctions'

export default function MessagesScreen () { 
  // получаю conversationID === 'new', если нет существующей беседы
    const { locUid, conversationID, locName } =  useParams()
    console.log('locUid',  locUid)
    const [messages, setMessages] = useState([])
    const [uid, setUid] = useState(null);
    const [read, setRead] = useState(false);
    const [readTime, setReadTime] = useState(null)
    // использую state для id беседы, чтобы при создании новой беседы значение id изменилось на новое, чтобы использовать его для загрузки новых сообщений
    const [ newConversationID, setNewConversationID] = useState(conversationID)

    function createConvr () {
      const messageInput = document.querySelector('#message');
      const message = messageInput.value;
      const date = new Date();
      const newDate = date.getTime();
      console.log('message', message, locUid, conversationID)
      if (message.length > 0 && newConversationID === 'new') {
        //просто создание беседы
          db.collection('conversations').add({ userA: uid, userB: locUid, [uid]: newDate, hasNewMessages: locUid })
              .then((docRef) => {
              messageInput.value = '';
              console.log('Conversation created');
              // получил id новой беседы
              const newConvId = docRef.id;
              //загрузил новое сообщение в новую беседу
              db.collection('conversations').doc(newConvId).collection('messages').add({ from: uid, text: message, date: newDate })
              .then(() => {
                console.log('Message sent');
                //поместил id новой беседы в state, чтобы на экране можно было загрузить сообщения из новой беседы
                setNewConversationID(newConvId);

                })
                .catch((error) => {
                  console.error(error);
                });
            })
            .catch((error) => {
              console.error(error);
            });
        }

  }
    useEffect(() => {
      const uid = auth.currentUser?.uid; 
      const conversationRef = db.collection("conversations").doc(newConversationID);
      console.log('newConversationID', newConversationID)
      setUid(uid);
      conversationRef.get().then((doc) => {
          const currentTime = Date.now();
          const convData = doc.data();
          const hasNewMessages = doc.data().hasNewMessages;
          setReadTime(convData[locUid])
          //Выполняю функцию загрузки сообщений
          getMessages(newConversationID, (newMessages) => {
            // Обновляем последнее время входа и проверяем, нужно ли обновлять hasNewMessages до null
            //(где null = отсутсвию новых сообщений для обоих), значение uid = новое сообщение для текущего пользователя, а locUid для собеседника
            if (hasNewMessages && hasNewMessages !== locUid) {
              // Обновляем значение поля hasNewMessages до null
              // Именно в момент загрузки сообщения обновляю время последнего прочтения в диалоге
              conversationRef.update({ [uid]: currentTime, hasNewMessages: null });
            } else {
              conversationRef.update({ [uid]: currentTime });
            }
            // for(let i =  newMessages.length - 1; i; i++)
            // "Пробегаю" по массиву сообщений newMessages с помощью цикла while и проверяю параметр date
            let i = newMessages.length - 1;
            while (i) { 
              const message = newMessages[i];
              if (convData[locUid] > message.date) {  
                setRead(i)
                break;
              } 
              i--;
            }
            // загружаю в messages обновлённый массив с сообщениями
            setMessages(newMessages);
            // Скроллим вниз списка после того, как он загрузится
            scrollToBottom()
        });
        });
        //насколько понимаю здесь работает зависимость от измениний в newConversationID 
    }, [newConversationID, locUid]);

    const scrollToBottom = () => {
        const messagesContainer = document.querySelector('#messagesContainer');
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
    
    const messg = async event => {
        event.preventDefault()
        const messageInput = document.querySelector('#message');
        const message = messageInput.value;
        const date = new Date()
        const newDate = date.getTime()
        console.log('conversationID', conversationID)
        if (conversationID !== 'new' && newConversationID !== 'new') 
         { message.length > 0 && db.collection('conversations').doc(conversationID).collection('messages')
          .add({ from: uid, text: message, date: newDate, })
          .then(() => {
            scrollToBottom();
            messageInput.value = '';
            db.collection("conversations").doc(conversationID).set({ hasNewMessages: locUid }, { merge: true })
            console.log('Message sent')
          })
          .catch(error => { console.error(error) });
      } else {createConvr()}
    }

    return (
        <div className="EventScreen" >
          <div className="EditVenuePage" style={{ 
            display: 'flex', 
            // width: '60vh', 
            height: '100vh',
            alignItems: 'center', 
            justifyContent: 'center', 
            padding: 10, 
            color: 'white', 
            flexDirection: 'column',
            }}>
            <h1 style={{marginBlock: '5px 15px'}}>{locName}</h1>
            <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 10 }} />
            <div id="messagesContainer" className='messagesContainerStyle'
              style={{ 
                }}>
              {messages && messages.map((message, index) => { 
                return(<MessageItem key={message.time} message={message} index={index} read={read} readTime={readTime} uid={uid}/>)
              })}
            </div>
            <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 10 }} />
            <form onSubmit={messg} style={{display: 'flex', flexDirection: 'row', width: '100%',}}>
              <input
                style={{ padding: 20, color: 'white', width: '100%', backgroundColor: 'var(--drg)', fontSize: 16,  }}
                placeholder={"Type a new message here"}
                name="message"
                id="message"
                autoCapitalize={'sentences'}
              />
              <button className='btnYorp' type='submit' style={{padding: '2px 16px', marginBlock: 5, fontSize: 16, borderWidth: 2}}>
                <FaPaperPlane />
              </button>
            </form>
          </div>
        </div>
      );
}